import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/PageHero";
import { Founder } from "../components/Founder";
import { ABOUT_STATS, VALUES } from "../data/content";

export default function AboutUs() {
  return (
    <PageShell>
      <PageHero
        eyebrow="About Us"
        title="A senior-led Dubai advisory,"
        italic="built on trust"
        subtitle="Universal Dream Properties LLC is a boutique real-estate practice connecting global investors with the UAE's most trusted developers — quietly, and with full transparency."
      />

      <section className="py-20 md:py-28 px-6 md:px-12">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden" data-testid="about-stats">
          {ABOUT_STATS.map((s) => (
            <div key={s.l} className="bg-[#0a1128] px-4 py-8 text-center">
              <div className="font-serif-display text-3xl md:text-4xl text-[#c5a059]">{s.v}</div>
              <div className="text-[10px] tracking-[0.3em] text-white/50 uppercase mt-2">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <Founder />

      <section className="py-20 md:py-28 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-[10px] tracking-[0.5em] text-[#c5a059] uppercase mb-6">Our values</div>
          <h2 className="font-serif-display text-3xl md:text-5xl font-light mb-14">
            What our clients <em className="italic gold-gradient">actually get</em>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {VALUES.map((v, i) => (
              <div key={v.title} className="glass rounded-2xl p-8" data-testid={`value-${i}`}>
                <div className="text-[10px] tracking-[0.4em] text-[#c5a059] mb-3">0{i + 1}</div>
                <h3 className="font-serif-display text-2xl mb-3">{v.title}</h3>
                <p className="text-white/60 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
